import { render, staticRenderFns } from "./commonDetailBase.vue?vue&type=template&id=066b6640&scoped=true&"
import script from "./commonDetailBase.vue?vue&type=script&lang=js&"
export * from "./commonDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./commonDetailBase.vue?vue&type=style&index=0&id=066b6640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b6640",
  null
  
)

export default component.exports